/*
 * main.tsx
 * Entry point of the application.
 * Bootstraps the React app with React.StrictMode and Flowbite provider.
 */
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App.tsx';
import './index.css';
import { Flowbite } from 'flowbite-react';

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <Flowbite>
      <App />
    </Flowbite>
  </React.StrictMode>
);
